import { GreenroomInviteUser, GreenroomInviteUserResponse } from '@/types/greenroom/profile.types';
import { Post } from '../helpers';

const SendGreenroomInvite = async (
  payload: GreenroomInviteUser,
  greenRoomToken: string
): Promise<GreenroomInviteUserResponse[]> => {
  return Post({
    host: import.meta.env.VITE_GREENROOM_API,
    url: '/v3/greenroom/create-invitations?unified_auth=1',
    body: payload,
    headers: {
      'bl-token': greenRoomToken,
      'bl-global-resource': 'false',
    },
  });
};

export default SendGreenroomInvite;
